import { c as _c } from "react/compiler-runtime";
import Markdown from 'react-markdown';
import { ButtonLink } from '@sbt-web/ui';
import ownClasses from './banner.module.scss';
interface Props {
  imageSrc: string;
  title: string;
  body: string;
  buttonText: string;
  buttonURL: string;
  /**
   * Set a fixed width for the banner image
   */
  imageWidth: number;
  /**
   * Set a fixed height for the banner image
   */
  imageHeight: number;
  imageAlt?: string;
}
const Banner = t0 => {
  const $ = _c(17);
  const {
    imageSrc,
    imageAlt,
    title,
    body,
    buttonText,
    buttonURL
  } = t0;
  const t1 = `${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/product-marketing/${imageSrc}`;
  let t2;
  if ($[0] !== imageAlt || $[1] !== t1) {
    t2 = <img src={t1} alt={imageAlt} width={260} loading="lazy" decoding="async" />;
    $[0] = imageAlt;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <Markdown>{title}</Markdown>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== body) {
    t4 = <Markdown>{body}</Markdown>;
    $[5] = body;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={ownClasses["description-wrapper"]}>{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== buttonText || $[11] !== buttonURL) {
    t6 = buttonText && buttonURL ? <ButtonLink href={buttonURL} target="_blank" design="solid-lite" size="medium">{buttonText}</ButtonLink> : null;
    $[10] = buttonText;
    $[11] = buttonURL;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t5 || $[15] !== t6) {
    t7 = <article className={ownClasses.banner}>{t2}{t5}{t6}</article>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default Banner;